import { AddCircleOutline } from "@mui/icons-material";
import { FormControl, FormHelperText, Typography } from "@mui/material";
import CreateClientDialog from "components/dialogs/client/CreateClientDialog";
import IndieButton from "components/forms/IndieButton";
import { useFormikContext } from "formik";
import ApplicationList from "page-sections/common/ApplicationList";
import { useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useClientsAPI } from "service/ClientsAPIService";

const SelectOrCreateClientStep = ({ community }) => {

    const { t } = useTranslation();
    const api = useClientsAPI();
    const { values, errors, setFieldValue } = useFormikContext();

    const [openCreateClientDialog, setOpenCreateClientDialog] = useState(false);
    const tableRef = useRef();

    const columns = useMemo(() => [
        { accessor: "name", Header: t("label.form.name") },
        { accessor: "fiscal_number", Header: t("label.form.fiscalNumber"), filter: "contains" },
        { accessor: "email", Header: t("label.table.header.email") },
        { accessor: "phone", Header: t("label.table.header.phone") },
    ], [t]);

    const dataFetcher = (filters = [], page_size = 30, page = 1, sortColumns, callBack, errorCallBack) => {
        api.fetchClients(
            [{ id: "agent_entity__entity__id", value: community?.agent_entity?.id }, ...filters],
            page_size, page, sortColumns, callBack, errorCallBack
        );
    };

    const handleRowClick = (row) => {
        setFieldValue("client", row);
        setFieldValue("client_id", row.id);
    };

    const handleCreateSuccess = (client) => {
        setOpenCreateClientDialog(false);
        handleRowClick(client);
        tableRef.current?.refreshData();
    };

    return (
        <FormControl fullWidth>
            <Typography variant="subtitle2" sx={{ mb: 2 }}>{t("label.step.selectClient.subtitle")}</Typography>
            <ApplicationList
                ref={tableRef}
                id="select_client_table"
                dataFetcher={dataFetcher}
                columns={columns}
                selectable
                selected={values.client}
                rowOnClick2={handleRowClick}
                outlined
                showAppBar
                appBar={[
                    <IndieButton key="create_client" id="button_create_client" startIcon={<AddCircleOutline />} variant="outlined" onClick={() => setOpenCreateClientDialog(true)}>
                        {t("label.button.createClient")}
                    </IndieButton>
                ]}
            />
            {errors.client_id && <FormHelperText id="client_id_helper_text" error>{errors.client_id}</FormHelperText>}
            <CreateClientDialog
                open={openCreateClientDialog}
                onClose={() => setOpenCreateClientDialog(false)}
                onSuccess={handleCreateSuccess}
                community={community}
            />
        </FormControl>
    );
};

export default SelectOrCreateClientStep;
